import QrCode, { fichaUrl } from "@/components/shared/QrCode";

/** QR Code da ficha no cabecalho da FCA: abre esta mesma ficha. */
export default function FcaHeaderQr({ treeId }: { treeId: number }) {
  if (!(treeId > 0)) return null;
  return (
    <div className="w-[96px] h-[96px] sm:w-[128px] sm:h-[128px] bg-white border-2 border-background-200 rounded-lg p-1.5 shrink-0" title="QR Code da ficha do exemplar">
      <QrCode value={fichaUrl(treeId)} alt="QR Code da ficha do exemplar" className="w-full h-full" />
    </div>
  );
}
